import React, { useState } from 'react';
import { CenterSummaryModel } from 'lib/salesforce/types';
import classnames from 'classnames';
import LinkA11yWrapper from 'components/helpers/LinkA11yWrapper';
import { GetColumnValueProps } from './lib/SaleforceTable';

const GetCenterTypeColumnValue = ({
  name,
  item,
}: GetColumnValueProps<CenterSummaryModel>): React.JSX.Element => {
  const [phoneNumber] = useState(() => {
    return {
      value: {
        href: item.PhoneNumber ? `tel:${item.PhoneNumber}` : '',
        text: item.PhoneNumber,
      },
    };
  });
  const [tollFreeNumber] = useState(() => {
    return {
      value: {
        href: item.TollFreeNumber ? `tel:${item.TollFreeNumber}` : '',
        text: item.TollFreeNumber,
      },
    };
  });
  const [website] = useState(() => {
    return {
      value: {
        href: item.Website,
        text: item.Name,
      },
    };
  });
  switch (name) {
    case 'Country':
      return <>{item.Address.Country}</>;
    case 'Name':
      return (
        <>
          {item.Website ? (
            <LinkA11yWrapper
              className={classnames('text-blue-morning')}
              editable={false}
              field={website}
            />
          ) : (
            item.Name
          )}
        </>
      );
    case 'Address':
      return (
        <>
          {[item.Address.Street, item.Address.City, item.Address.State, item.Address.PostalCode]
            .filter((addressPart) => !!addressPart) // Remove null or undefined parts
            .join(', ')}
        </>
      );
    case 'PhoneNumber':
      return (
        <>
          {item.PhoneNumber && (
            <LinkA11yWrapper
              className={classnames('text-blue-morning', 'block')}
              editable={false}
              field={phoneNumber}
            />
          )}
          {item.TollFreeNumber && (
            <LinkA11yWrapper
              className={classnames('text-blue-morning', 'block')}
              editable={false}
              field={tollFreeNumber}
            />
          )}
        </>
      );
    default:
      return <></>;
  }
};

export default GetCenterTypeColumnValue;
